import accessesIcon from '../assets/assesses/accesses.svg'
import truckIcon from '../assets/equipment/truck.svg'
import diplomaIcon from '../assets/sidemenu/diploma-active.svg'
import boxIcon from '../assets/sidemenu/box-active.svg'
import productionIcon from '../assets/home/production.svg'
import localIcon from '../assets/sidemenu/local-active.svg'
import clipboardIcon from '../assets/sidemenu/clipboard-active.svg'
import steelIcon from '../assets/home/steel.svg'
import resourceIcon from '../assets/home/resource.svg'
import serviceIcon from '../assets/home/service.svg'
import hangerIcon from '../assets/home/hanger.svg'
import lengthIcon from '../assets/home/length.svg'
import companiesIcon from '../assets/home/companies.svg'
import vendasAcoIcon from '../../src/assets/home/orders.svg'
import collectionsIcon from '../assets/home/shirt.svg'
import familyIcon from '../assets/home/family.svg'

export interface ModuleConfig {
  name: string
  path: string
  image: string
  section: string
  permission: string
  dependencies?: string[]
}


export const industrialModules: ModuleConfig[] = [
  {
    name: 'Certificados',
    path: 'certificates',
    image: diplomaIcon,
    section: 'Aplicações',
    permission: 'certificates',
    dependencies: ['stock']
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Produção',
    path: 'production',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['stock', 'orders']
  },
  {
    name: 'Vendas Aço',
    path: 'steel',
    image: vendasAcoIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },
  
  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Rastreio de pedidos',
    path: 'orders',
    image: clipboardIcon,
    section: 'Banco de dados',
    permission: 'orders'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  }
]


export const fashionModules: ModuleConfig[] = [
  {
    name: 'Pedidos fashion',
    path: 'fashion',
    image: hangerIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Produção fashion',
    path: 'production-fashion',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['orders']
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },
  
  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  },
  {
    name: 'Coleções',
    path: 'collections',
    image: collectionsIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Famílias',
    path: 'families',
    image: familyIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Composição de produto',
    path: 'product-composition',
    image: lengthIcon,
    section: 'Banco de dados',
    permission: 'products'
  }
]


export function hasModulePermission(module: ModuleConfig, userPermissions: string[]): boolean {

  if (module.permission === 'public') {
    return true
  }
  

  const hasMainPermission = userPermissions.includes(module.permission)
  


  if (hasMainPermission) {
    return true
  }
  
  return false
}


export function getModulesForTenant(tenantId: number | null): ModuleConfig[] {

  if (tenantId === null) return []


  if (tenantId === 2) {
    return fashionModules
  }


  return industrialModules
}


export function getModulesForTenantWithPermissions(tenantId: number | null, userPermissions: string[]): ModuleConfig[] {
  if (tenantId === null) return []

  const allModules = getModulesForTenant(tenantId)

  return allModules.filter(module => hasModulePermission(module, userPermissions))
}


export function getModulesBySection(tenantId: number | null) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenant(tenantId)
  
  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)
  

  const orderedSections: Record<string, ModuleConfig[]> = {}
  
  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }
  
  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }
  
  return orderedSections
}


export function getModulesBySectionWithPermissions(tenantId: number | null, userPermissions: string[]) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenantWithPermissions(tenantId, userPermissions)
  
  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)
  

  const orderedSections: Record<string, ModuleConfig[]> = {}
  
  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }
  
  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }
  
  return orderedSections
}


export function canEditStock(userPermissions: string[]): boolean {
  return userPermissions.includes('edit-stock')
}